
import { createRadioBase } from 'JS/components/blain-form/BRadioBase';
import {  defineComponent, PropType } from 'vue';
import { IWarranty } from 'JS/types/Product';

const { withRadioBaseProps, useRadioBase } = createRadioBase<string>();

export default defineComponent({
	props: {
		warranty: { type: Object as PropType<IWarranty>, required: true },
		showRadioIcon: { type: Boolean, required: false, default: false },
		...withRadioBaseProps(),
	},
	setup (props, { emit }) {
		return {
			...useRadioBase(props, emit),
		};
	}
});
